export default __webpack_public_path__ + "static/PADI-light-d439740b4052958e95cbf94bfd8bf2f5.svg";